import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useRouteSlug } from "@/hooks";
import { TILE_DATA } from "@/constants";
import CommonAnalyticsEvent from "@/services/analytics/main/common";
import RightArrowImg from "../../images/arrow-point-to-right.svg";

const HelpDetailsTopicsSection = () => {
  const routeSlug = useRouteSlug();
  const { t } = useTranslation("needHelp");

  const handleViewAllFaq = category => {
    CommonAnalyticsEvent.viewAllFaq({
      category: t(`${category?.data || category}`).toLowerCase()
    });
  };

  return (
    <div className="topics_section">
      <h4>{t("topics")}</h4>
      <ul>
        {TILE_DATA.map((category, index) => (
          <li key={index}>
            <Link
              to={`/${routeSlug}${category.link}`}
              onClick={() => handleViewAllFaq(category)}
            >
              <h5>
                {t(category.data)}
                <img src={RightArrowImg} alt="right-arrow" />
              </h5>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HelpDetailsTopicsSection;
